import { Button, ButtonGroup, Modal } from '@nike/eds';
import { useDispatch, useSelector } from 'react-redux';
import { useOktaAuth } from '@okta/okta-react';
import { StoreDispatch } from '../../shared/store/Store';
import { flushFilingPacks, selectIsFlushFilingPacksModalVisible, toggleFlushFilingPacksModal } from '../../shared/store/reducers/OverviewReducer';

export function FlushFilingPacksConfirmationModal() {
    const dispatch: StoreDispatch = useDispatch();
    const { authState } = useOktaAuth();

    const isModalVisible = useSelector(selectIsFlushFilingPacksModalVisible) as boolean;
    const userId = (authState?.idToken?.claims?.email as string ?? '').split('@')[0];

    const onClickDismiss = () => {
        dispatch(toggleFlushFilingPacksModal(false));
    }

    const onClickSubmit = () => {
        dispatch(flushFilingPacks(userId));
    }

    return (
        <Modal
            isOpen={isModalVisible}
            onDismiss={onClickDismiss}
            headerSlot="Flush Filing Packs Confirmation"
            footerSlot={
                <ButtonGroup>
                    <Button onClick={onClickSubmit} size="small">
                        Confirm
                    </Button>
                    <Button onClick={onClickDismiss} size="small" variant="secondary">
                        Cancel
                    </Button>
                </ButtonGroup>
            }
        >
            <div style={{minWidth: "500px"}}>
                <p className="eds-type--body-2">
                    Are you sure you want to flush Filing Packs?
                </p>
            </div>
        </Modal>
    )
}
